import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { setFormValue, setValidValue } from "../insuranceSlice";

export const useInsuranceValidation = (fieldName, options = {}) => {
  const dispatch = useDispatch();
  const { formValues } = useSelector((state) => state.insurance);
  const value = formValues[fieldName] ?? "";

  const { required = true, validate = () => "", transformValue = (v) => v } = options;

  const [touched, setTouched] = useState(false);
  const [error, setError] = useState("");

  const runValidation = useCallback(
    (val) => {
      let err = "";
      if (required && !val) err = `El campo es requerido`;
      else err = validate(val);

      setError(err);
      dispatch(setValidValue({ field: fieldName, isValid: !err }));
      return err;
    },
    [dispatch, fieldName, required, validate]
  );

  const handleChange = useCallback(
    (e) => {
      const newValue = transformValue(e.target.value);
      dispatch(setFormValue({ field: fieldName, value: newValue }));
      runValidation(newValue);
    },
    [dispatch, fieldName, transformValue, runValidation]
  );

  const handleBlur = useCallback(() => {
    setTouched(true);
    runValidation(value);
  }, [value, runValidation]);

  useEffect(() => {
    if (touched) runValidation(value);
  }, [value, touched, runValidation]);

  return {
    value,
    error,
    isInvalid: touched && !!error,
    getErrorMessage: () => (touched ? error : ""),
    onChange: handleChange,
    onBlur: handleBlur,
  };
};
